// valid duration for invitation
export const INVITE_VALID_DURATION_MONTH = 1;

const mailConfig = {
  noReplyFrom: {
    name: "HSNA-no-replay",
    address: "daoyidh.cc.noreply@gmail.com",
  },
};

/**
 * create email template for invitation to join group for someone
 * @param inviter {{emai:string;name:string;}}
 * @param invitee {{email:string;}}
 * @param inviteLink {string}
 *
 * @returns {{sendMail: {subject: string, from: {address: string, name: string}, to: *, text?: string, html?: string}}|null}
 */
export const generateInvitationToGroup = (
  inviter,
  invitee,
  inviteLink,
  group
) => {
  if (!(inviter && inviter.email && inviter.name && invitee?.email))
    return null;

  return {
    sendMail: {
      from: {
        name: inviter.name,
        address: inviter.email,
      },
      to: invitee.email,
      subject: `${inviter.name}(${inviter.email}) 邀請你加入【社會網絡分析平台】的群組`,
      html: `<h3>【HSNA】 數位人文工具的新選項，邀你一同進入數位人文的領域</h3>
<br>
<strong>${inviter.name}</strong>(${
        inviter.email
      }) 邀請你加入<strong>【社會網絡分析平台】</strong>的群組「${group.displayName || ""}」
<br>
請點選以下連結加入平台：
<br>
<a href="${inviteLink}">${inviteLink}</a>
<br>
此連結有效期限： ${INVITE_VALID_DURATION_MONTH * 30} 天 
`,
    },
  };
};

/**
 * create email template for invitation to join SNA platform for someone
 * @param inviter {{emai:string;name:string;}}
 * @param invitee {{email:string;}}
 * @param inviteLink {string}
 *
 * @returns {{sendMail: {subject: string, from: {address: string, name: string}, to: *, text: string}}|null}
 */
export const generateInvitationToPlatform = (inviter, invitee, inviteLink) => {
  if (!(inviter && inviter.email && inviter.name && invitee?.email))
    return null;

  return {
    sendMail: {
      from: mailConfig.from,
      to: invitee.email,
      subject: "邀請你加入【社會網絡分析平台】",
      text: `數位人文工具的新選項，邀你一同進入數位人文的領域

請點選以下連結加入平台：
${inviteLink}`,
    },
  };
};
